import { render, staticRenderFns } from "./FolderPicker.vue?vue&type=template&id=59a4928b"
import script from "./FolderPicker.js?vue&type=script&lang=js&external"
export * from "./FolderPicker.js?vue&type=script&lang=js&external"
import style0 from "./FolderPicker.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports